import { createHttpEndpoint } from '../../../utils'

import type { GetBackshipShippers } from './shippers.types'
/**
 * Returns backShip shippers available in the merchant's country if the merchant
 * has a sale address, otherwise it returns all backship shippers
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/shipping-backship-api/definition#tag/backship/operation/GetBackshipShippers}
 */
export const getBackshipShippers = createHttpEndpoint<GetBackshipShippers>({
  method: 'GET',
  operationId: 'getBackShipShippers',
  path: '/bm/shipping/backship/shippers',
})
